import { render } from "./TransactionDetialPageWithId.vue?vue&type=template&id=dc3d474c"
import script from "./TransactionDetialPageWithId.vue?vue&type=script&lang=js"
export * from "./TransactionDetialPageWithId.vue?vue&type=script&lang=js"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__